export default __webpack_public_path__ + "static/media/logo-mobile.99c6c034.svg";